// RECETTE API BASE URL
// var api = 'https://api-recette.diekkes.com/api/';

// PRODUCTION API BASE URL
var api = "https://www.back.django.diekkes.com/api/";

export default api;
